import classNames from './CloseConversationModal.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';
import TutorAvatarIcon from '@/components/ConversationWithTutor/TutorAvatarIcon/TutorAvatarIcon';

interface CloseConversationModalProps {
  show: boolean;
  handleConfirm: () => void;
  handleCancel: () => void;
  title?: any;
  description?: any;
  cancelBtnText?: string;
  confirmBtnText?: string;
  showBackdrop?: boolean;
}

const CloseConversationModal = ({
  show,
  handleConfirm,
  handleCancel,
  title,
  description,
  cancelBtnText,
  confirmBtnText,
  showBackdrop = true,
}: CloseConversationModalProps) => {
  const { t } = useTranslation();

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            {showBackdrop && (
              <AppBackdrop className={classes(classNames.backdrop, `backdrop-${state}`)} />
            )}
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                <TutorAvatarIcon className={classNames.icon} animate={false} />
                <h2>{title || t('tutorRouterPrompt.title')}</h2>
                <div className={classNames.description}>
                  {description || t('tutorRouterPrompt.description')}
                </div>
                <div className={classNames.buttons}>
                  <TheButton
                    className={classNames.cancelBtn}
                    text={cancelBtnText || t('tutorRouterPrompt.cancelBtn')}
                    shouldRecolor={false}
                    emitOnClick={handleCancel}
                  />
                  <TheButton
                    className={classNames.confirmBtn}
                    text={confirmBtnText || t('tutorRouterPrompt.confirmBtn')}
                    plain={true}
                    shouldRecolor={false}
                    emitOnClick={handleConfirm}
                  />
                </div>
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default CloseConversationModal;
